import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FolderAddOutlined } from '@ant-design/icons';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';

import * as actions from '@redux/global/actions';

import * as companySelectors from 'pages/company/controllers/selectors';
import * as assetFullViewSelector from 'pages/asset-full-view/controllers/selectors';

import Messages from 'i18n/messages/home';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { useGlobalModal } from 'hooks';

const AddFolderControl = ({ selectedItemList }) => {
  const dispatch = useDispatch();

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const companyInfo = useSelector(companySelectors.setlectCompanyInfo());
  const assetFullView = useSelector(
    assetFullViewSelector.makeSelectAssetData()
  );

  const isMemOrAssetDetailView = companyInfo?.id || assetFullView?.id;

  const addToFolderClick = () => {
    if (isMemOrAssetDetailView) {
      openModal(MODAL_NAMES.ADD_ITEMS_TO_FOLDER);
    } else dispatch(actions.toggleAddToFolder());
  };

  const allowViewFolder = useCheckPermissions([
    { action: ABILITY_ACTION.VIEW, subject: ABILITY_SUBJECT.FOLDER },
  ]);

  return (
    <ButtonSmallIcon
      icon={<FolderAddOutlined />}
      label={Messages.addFolder}
      className='button-item-dropdown'
      disabled={
        !allowViewFolder ||
        disableButton(window.location.pathname) ||
        (selectedItemList && selectedItemList.length === 0)
      }
      onClick={addToFolderClick}
    />
  );
};

const urlFolders = [
  '/folders',
  '/folders/shared',
  '/folders/owned',
  '/favorite/favorite-folders',
];

const disableButton = (pathname) => {
  return urlFolders.includes(pathname);
};

AddFolderControl.propTypes = {};

export default AddFolderControl;
